import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Asegúrate de tener el archivo App.js o la ruta correcta
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
